import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { FormFieldsContainer } from '../../Form'
import { FormikField } from '../../Formik'
import { InputField } from '../../Input'
import { Switch } from '../../Switch'
import {
  FILTER_TEMPLATE_NAME_FIELD,
  FILTER_TEMPLATE_NAME_FIELD_PUBLIC,
  FILTER_TEMPLATE_NAME_MAX_LENGTH,
} from '../Filter.constants'

import * as styles from './FilterSaveModalFields.module.css'

function FilterSaveModalFields(props) {
  const { t } = useTranslation()

  return (
    <FormFieldsContainer>
      <FormikField
        {...props}
        clearable
        hasCounter
        required
        Component={InputField}
        label={t('Input.TemplateNameLabelKey')}
        maxLength={FILTER_TEMPLATE_NAME_MAX_LENGTH}
        name={FILTER_TEMPLATE_NAME_FIELD}
        placeholder={t('Input.TemplateNamePlaceholderKey')}
      />
      <FormikField
        Component={Switch}
        Field={Fragment}
        className={styles.public}
        label={`${t('Modal.MakeTeplatePublicLabelKeyKey')}:`}
        labelProps={{ isSecondary: true }}
        name={FILTER_TEMPLATE_NAME_FIELD_PUBLIC}
      />
    </FormFieldsContainer>
  )
}

export default FilterSaveModalFields
